<template>
    <div id="questionDetail">
        <div class="info" v-for="(item,index) in dataList" :key="index">            
            <div class="line">
                <label>工单号：</label>
                <div><span>{{ item.id }}</span></div>
            </div>
            <div class="line">
                <label>问题描述：</label>
                <div class="moreInfo">{{ item.remark }}</div>
            </div> 
             <div class="line">
                    <label>反馈时间：</label>
                    <div>{{ item.createTime }}</div>
                </div>
            <div class="line">
                    <label>处理状态：</label>
                    <div class="moreInfo">{{ item.stateName }}</div>
                </div>       
            <div class="line">
                <label>处理方案：</label>
                <div class="moreInfo">{{ item.disRemark }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import {wxRequest} from '@/api/user'
export default {
    data(){
        return {
            dataList:[]
        }
    },
    methods: {

    },
    created(){
       this.dataList= this.$store.state.subList;
    }
    
}
</script>
<style lang="less">
#questionDetail {
    h4 {
        color: #fff;
        line-height: 36px;
        text-align: center;
        &.processed {
            background: #0c931b;
        }
        &.unprocessed {
            background: #ff362c;
        }
    }
    .info {
        padding: 0 4%; 
        border-bottom:1px solid #dedede;
        &:last-child{
            border:none; 
        }
    }

}
</style>
